export default __webpack_public_path__ + "static/media/IMG_061.ecef7281.jpg";